export default {
	'profileEdit.addNewCompany': 'Add New Company',
	'profileEdit.addFileToFileManager': 'Add file to file manager',
	'profileEdit.addJobTitle': 'You must add a job title',
	'profileEdit.certification': 'Certification',
	'profileEdit.companies': 'Companies',
	'profileEdit.errorFileToFileManager': 'There was an error adding this file to the filemanager.',
	'profileEdit.errorSaving': 'Error Saving Your Details',
	'profileEdit.noCertificationsAvailable': 'No certifications are available for this provider.',
	'profileEdit.noInsuranceTypesAvailable': 'No insurance types are available for this industry.',
	'profileEdit.noLicensesAvailable': 'No licenses are available in this state.',
	'profileEdit.noProvidersAvailable': 'No providers are available in this industry.',
	'profileEdit.problemDeletingResume': 'There was a problem deleting your resume.',
	'profileEdit.provider': 'Provider',
	'profileEdit.selectIndustryDisplay': 'Select an industry to display list of available vendors.',
	'profileEdit.selectionFirst': 'You must make a selection first!',
	'profileEdit.updatingList': 'Updating list'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/profileedit.js